<mat-list id="data-list">
  <mat-list-item  *ngFor="let result of result" id="result-box">
    <a [routerLink]="['/'+(result.isProgram ? 'program' : 'organization'), result.id]">
      <h1>{{result.name}}</h1>
      <h2>{{result.info}}</h2>
    </a>
  </mat-list-item>
</mat-list>
